

import Vue from 'vue'
import Component from "vue-class-component";
import {IOnOffHandlers} from "bonomo/dist";
import {Prop} from "vue-property-decorator";
import {namespace} from "vuex-class";
import {IErrors} from "@/model/IErrors";

const settingsModule = namespace("settingsModule");

@Component({})
export default class LandingPageCreationDialog extends Vue {
  @Prop()
  private show!: boolean;

  @settingsModule.Action('createLandingPage')
  private createLandingPage!: (myObj: any) => void;

  @settingsModule.Action('resetErrors')
  private resetErrors!: () => void;

  @settingsModule.Getter('errors')
  private errors!: IErrors;

  private subscribes: IOnOffHandlers = {};

  private slug: string|null = null;
  private tag: string|null = null;

  private loading: boolean = false;

  created() {
    this.subscribes = this.$ons({
      'login.OK': this.onClose,
      'backend.call.OK.landingPageCreated': this.onBackendOk,
      'backend.call.KO.landingPageCreated': this.onBackendKO,
    });
  }

  beforeDestroy() {
    this.$offs(this.subscribes);
  }

  private onBackendOk() {
    this.onClose();
    this.loading = false;
  }

  private onBackendKO() {
    this.loading = false;
  }

  private onClose() {
    this.$emit('close');
    this.resetErrors();
  }

  private onCreate(){
    this.loading = true;
    this.createLandingPage({
      slug: this.slug,
      tag: this.tag,
    })
  }

}
